import { useMemo } from "react";

export default function SeparatorToNewLine({
  value = "",
  separator = "\s{0,},\s{0,}",
  valueOnEmpty = "-"
}: {
  value: any;
  /** regex string */
  separator?: string;
  valueOnEmpty?: string;
}) {
  const memoized = useMemo(() => {
    const reg = new RegExp(separator, "gi");
    const items = value.split(reg);

    return <>
      {items.length === 0 && valueOnEmpty && {valueOnEmpty}}
      {items.length > 0 && items.map((value, i) => {
        return <div key={i}>{value}</div>
      })}
    </>
  }, [value]);

  return <>{memoized}</>;
}
